<div nz-row nzJustify="space-between" style="margin-bottom: 8px; margin-top: 8px;">
  <div nz-col nzSpan="8">
    <nz-input-group nzPrefixIcon="search" [nzSuffix]="inputClearTpl">
      <input type="text" nz-input i18n-placeholder
             placeholder="search production order"
             [nzAutocomplete]="auto"
             (input)="onSearchInput($event)"
             [ngModel]="poNamePrefix"
             (ngModelChange)="onSearch($event)"
             (keydown.enter)="onSearchEnter($event)" />
    </nz-input-group>
    <ng-template #inputClearTpl>
      @if (poNamePrefix) {
      <span
            nz-icon
            class="ant-input-clear-icon"
            nzTheme="fill"
            nzType="close-circle"
            (click)="onSearch(undefined)"></span>
      }
    </ng-template>
    <nz-autocomplete [nzDataSource]="poLabels" nzBackfill [nzDefaultActiveFirstOption]="true" #auto></nz-autocomplete>
  </div>
  <div nz-col nzSpan="4"></div>
  <div class="filters" nz-col nzSpan="10">
    <nz-radio-group nzButtonStyle="solid" [(ngModel)]="currentOnly" (ngModelChange)="onSliceChange($event)">
      <label nz-radio-button i18n [nzValue]="true">Current</label>
      <label nz-radio-button i18n [nzValue]="false">All</label>
    </nz-radio-group>
  </div>
</div>
<nz-table #poBatchTable
          [nzData]="state.allLoaded"
          [nzVirtualForTrackBy]="trackByIndex"
          [nzBordered]="true"
          [nzVirtualItemSize]="virtualItemSize"
          [nzVirtualMinBufferPx]="virtualItemSize * 10"
          [nzVirtualMaxBufferPx]="virtualItemSize * 10"
          nzFrontPagination="false"
          nzShowPagination="false"
          [nzScroll]="{ y: 'calc(100vh - 276px)' }">
  <thead>
    <tr>
      <th nzWidth="60px" i18n>#</th>
      <th nzWidth="100px" i18n>Status</th>
      <th nzWidth="40px"><span nz-icon nzType="camera"></span></th>
      <th nzWidth="120px" i18n>PO / Batch</th>
      <th nzWidth="60px" i18n>Color</th>
      <th nzWidth="20px"></th>
      <th nzWidth="100px" i18n>Base</th>
      <th nzWidth="60px" i18n>Producing</th>
      <th nzWidth="60px" i18n>Ordered</th>
      <th nzWidth="60px" i18n>Remaining</th>
      <th nzWidth="60px" i18n>Inspected </th>
      <th nzWidth="80px" i18n>Failed </th>
      <th nzWidth="100px" i18n>dE-CI(max)</th>
      <th nzWidth="50px" i18n>CI </th>
      <th nzWidth="100px" i18n>Started</th>
      <th nzWidth="100px" i18n>Modified (Started)      </th>
      <th nzWidth="100px" i18n>Actions</th>
    </tr>
  </thead>
  <tbody>
    <ng-template nz-virtual-scroll let-batch let-index="index">
      <tr
          [routerLink]="['/pos', batch.id]"
          [style.background-color]="batch.state == PoState.IsInspected || batch.current ? 'lightgreen' : batch.next? 'lightblue': undefined"
          [@highlight]="batch.modifiedTime?.getTime()">
        <td>
          {{ batch.inspectionSequence }}
        </td>
        <td>
          <app-batch-status-icon [status]="batch.state"></app-batch-status-icon>
          {{ batch.state | i18nSelect: poStateTranslation }}
        </td>
        <td>{{ batch.scannerId }}</td>
        <td (click)="$event.stopPropagation()">
          <button nz-button nzType="text" nzSize="small" nz-tooltip
                  style="padding: 0 4px; height: 22px; vertical-align: baseline;"
                  [cdkCopyToClipboard]="batch.poName"
                  (click)="onPoNameCopied(batch.id); $event.stopPropagation()"
                  i18n-nzTooltipTitle nzTooltipTitle="Copy PO number"
                  i18n-aria-label aria-label="Copy PO number">
            <span nz-icon [nzType]="copiedBatchId() === batch.id ? 'check' : 'copy'"></span>
          </button>
          <a [routerLink]="['/pos', batch.id]">{{ batch.poName }}
            /{{ batch.sequenceInPo + 1 }}</a></td>
        <td>
          <div [style.background]="colorPicker(batch.color?.lab)" class="color-div" nz-tooltip [nzTooltipTrigger]="batch.color?.lab?.l>0 ? 'hover' : null"
               [nzTooltipTitle]="colorTooltip"></div>
          {{ batch.color.code }}

          <ng-template #colorTooltip>
            <p>{{ toColorTooltip(batch.color, 1) }}</p>
            <p>{{ toColorTooltip(batch.color, 8) }}</p>
            <p>LAB - L: {{ batch.color?.lab.l.toFixed(1) }}, A: {{ batch.color?.lab.a.toFixed(1) }},
              B: {{ batch.color?.lab.b.toFixed(1) }}</p>
          </ng-template>
        </td>
        <td><app-formulation-color-preview [color]="batch.color"></app-formulation-color-preview></td>
        <td>
          {{ data[batch.baseMaterialId.toString()] || batch.baseMaterialId }}
        </td>
        <td>
          {{ batch.producingQuantity }}@if (batch.sequenceInPo>0) {
          ({{ batch.totalProducingQuantity }})
          }
        </td>
        <td>
          {{ batch.orderedQuantity }}
        </td>
        <td>
          {{ batch.remainingQuantity }}@if (batch.sequenceInPo>0) {
          ({{ batch.totalRemainingQuantity }})
          }
        </td>
        <td>
          {{ batch.inspectedQuantity }}@if (batch.sequenceInPo>0) {
          ({{ batch.totalInspectedQuantity }})
          }
        </td>
        <td>
          {{ batch.failedQuantity ? batch.failedQuantity : "" }}
        </td>
        <td>
          {{ batch.dEAvg ? (batch.dEAvg | number : '1.2-2') : "∅" }}
          ({{ batch.dEMax ? (batch.dEMax | number : '1.2-2') : "∅" }})
        </td>
        <td>
          {{ batch?.scans[0]?.ci ? (batch.scans[0].ci | number : '1.2-2') : "" }}
        </td>

        <td>{{ batch.startedTime | date:'yyyy-MM-dd HH:mm:ss' }}</td>

        <td nz-tooltip [nzTooltipTitle]="modifiedTooltip">
          {{
          batch.modifiedTime | dateTimeFromJsDate | dateTimeToRelative:{
          unit: ['days', 'hours', 'minutes', 'seconds'],
          style: 'short'
          }
          }}
          ({{
          batch.startedTime | dateTimeFromJsDate | dateTimeToRelative:{
          unit: ['days', 'hours', 'minutes', 'seconds'],
          style: 'short'
          }
          }})
          <ng-template #modifiedTooltip>
            <span>Last modified Time: {{ batch.modifiedTime | date:'yyyy-MM-dd HH:mm:ss' }}</span>
          </ng-template>
        </td>
        <td>
          @if (batch | canTransit: PoState.Running) {
          <button
                  (click)="attachDialog.show(batch); $event.stopPropagation()"
                  nz-button i18n-nzTooltipTitle nzType="dashed" nzShape="circle" nzSize="large" nz-tooltip
                  nzTooltipTitle="Attach">
            <span nz-icon nzType="group"></span>
          </button>
          }
          @if (batch | canTransit: PoState.Suspended) {
          <button
                  nz-popconfirm
                  (click)="$event.stopPropagation()"
                  i18n-nzPopconfirmTitle nzPopconfirmTitle="Are you sure you want to truncate?"
                  (nzOnConfirm)="truncate(batch, -1)"
                  (nzOnCancel)="cancel()"
                  nzPopconfirmPlacement="top"
                  nz-button i18n-nzTooltipTitle nzType="dashed" nzShape="circle" nzSize="large" nz-tooltip
                  nzTooltipTitle="Truncate">
            <span nz-icon nzType="minus-circle"></span>
          </button>
          }
          @if (batch | canTransit: PoState.Suspended) {
          <button
                  (click)="state.suspend(batch.id); $event.stopPropagation()"
                  nz-button i18n-nzTooltipTitle nzType="dashed" nzShape="circle" nzSize="large" nz-tooltip
                  nzTooltipTitle="Suspend">
            <span nz-icon nzType="pause-circle"></span>
          </button>
          }
          @if (batch | canTransit: PoState.Bypassed) {
          <button
                  (click)="state.bypass(batch.id); $event.stopPropagation()"
                  nz-button i18n-nzTooltipTitle nzType="dashed" nzShape="circle" nzSize="large" nz-tooltip
                  nzTooltipTitle="Bypass">
            <span nz-icon nzType="eye-invisible"></span>
          </button>
          }
          @if (batch | canTransit: PoState.IsInspected) {
          <button
                  (click)="state.inspect(batch.id); $event.stopPropagation()"
                  nz-button i18n-nzTooltipTitle nzType="dashed" nzShape="circle" nzSize="large" nz-tooltip
                  nzTooltipTitle="Inspect">
            <span nz-icon nzType="play-circle"></span>
          </button>
          }
          <button
                  [disabled]="!isAdmin()"
                  (click)="previewBatch.set(batch); $event.stopPropagation()"
                  nz-button i18n-nzTooltipTitle nzType="dashed" nzShape="circle" nzSize="large" nz-tooltip
                  nzTooltipTitle="View JSON">
            <span nz-icon nzType="code"></span>
          </button>
          @if (isAdmin()) {
          <button
                  nz-popconfirm
                  (click)="$event.stopPropagation()"
                  i18n-nzPopconfirmTitle nzPopconfirmTitle="Delete this batch and ALL its scans? Image files on disk and images_links rows will also be removed. This cannot be undone."
                  (nzOnConfirm)="deleteBatch(batch)"
                  (nzOnCancel)="cancel()"
                  nzPopconfirmPlacement="topRight"
                  nz-button nzDanger i18n-nzTooltipTitle nzType="dashed" nzShape="circle" nzSize="large" nz-tooltip
                  nzTooltipTitle="Delete batch + all its scans">
            <span nz-icon nzType="delete"></span>
          </button>
          }
        </td>
      </tr>
    </ng-template>
  </tbody>
</nz-table>
<app-po-attach-dialog #attachDialog (onSelect)="attach($event)"
                      (onBypass)="state.bypass($event.id)"></app-po-attach-dialog>

@if (previewBatchTitle()) {
  <app-json-object-preview
    [data]="previewBatch()"
    [title]="previewBatchTitle()"
    (closed)="previewBatch.set(null)"
  ></app-json-object-preview>
}
